import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {AchievementsPageComponent} from "./pages/achievements/achievements-page.component";
import {DropAttributesPageComponent} from "./pages/attributes/drop.attributes-page.component";
import {LevelsAttributesPageComponent} from "./pages/attributes/levels.attributes-page.component";
import {ProfileAttributesPageComponent} from "./pages/attributes/profile.attributes-page.component";
import {WeightsAttributesPageComponent} from "./pages/attributes/weights.attributes-page.component";
import {BuffsPageComponent} from "./pages/buffs/buffs-page.component";
import {ConstsPageComponent} from "./pages/consts-page/consts-page.component";
import {GoPageRoutes} from "./pages/go/go-page-routing.module";
import {HomePageRoutes} from "./pages/home/home-page-routing.module";
import {GeneratorsLocationPageComponent} from "./pages/location/generators.location-page.component";
import {MapsLocationPageComponent} from "./pages/location/map.location-page.component";
import {LoginPageComponent} from "./pages/login-page/login-page.component";
import {MainPageComponent} from "./pages/main/main-page.component";
import {OffersPageComponent} from "./pages/offers/offers-page.component";
import {LevelsPremiumShopPageComponent} from "./pages/prem_shop/levels.premium-shop.page.component";
import {LotsPremiumShopPageComponent} from "./pages/prem_shop/lots.premium-shop.page.component";
import {QuestPageComponent} from "./pages/quest-page/quest-page.component";
import {SearchPageComponent} from "./pages/search-page/search-page.component";
import {SpellPageComponent} from "./pages/spells/spells-page.component";
import {StoryComponent} from "./pages/stories/stories-page.component";
import {TestComponent} from "./pages/test/test.component";
import {TextPageComponent} from "./pages/text-page/text-page.component";
import {AtlasesComponent} from "./pages/atlases/atlases-page.component";
import { LocalesListPageComponent } from './pages/locales-list-page/locales-list-page.component';
// import {MainPageComponent} from "./pages/main-page/main-page.document";
import {AuthGuardService} from "./services/auth-guard.service";
import {AuthService} from "./services/auth.service";
import {UnsavedGuard} from "./services/unsaved-guard.service";
import {LogsPageComponent} from "./pages/logs/logs-page.component";
import {OnmapDialogsComponent} from "./pages/onmap-dialogs/onmap-dialogs.component";
import {OfferLotsComponent} from "./pages/prem_shop/offer-lots.premium-shop-page.component";
import {MonetaryGroupsPageComponent} from "./pages/offers-restrictions-groups/monetary-groups-page/monetary-groups-page.component";
import {FrequencyGroupsPageComponent} from "./pages/offers-restrictions-groups/frequency-groups-page/frequency-groups-page.component";
import {RecencyGroupsPageComponent} from "./pages/offers-restrictions-groups/recency-groups-page/recency-groups-page.component";
import {GoTagsPageComponent} from "./pages/go-tags-page/go-tags-page.component";
import {QuestArcPageComponent} from "./pages/quest-arc-page/quest-arc-page.component";
import {GameEventPageComponent} from "./pages/game-event-page/game-event-page.component";
import {GameEventMapPageComponent} from "./pages/game-event-map-page/game-event-map-page.component";
import {TemplateTypesPageComponent} from "./pages/template-types-page/template-types-page.component";
import {AdvertisementComponent} from "./pages/advertisement/advertisement.component";
import {AdNetworksComponent} from "./pages/ad-networks/ad-networks.component";
import {GeosListPageComponent} from "./pages/geos-list-page/geos-list-page.component";
import {OfferTypesListPageComponent} from "./pages/offer-types-list-page/offer-types-list-page.component";


const routes: Routes = [
  {
    path: "login",
    component: LoginPageComponent, data: {hidden: true}
  },
  {
    path: "",
    component: MainPageComponent,
    canActivate: [AuthGuardService],
    children: [
      ...HomePageRoutes,
      {
        path: "search",
        data: {name: "Поиск"},
        component: SearchPageComponent
      },
      {
        path: "questsMain",
        data: {name: "Квесты"},
        children:[
          {
            path: "quests",
            data: {name: "Квесты"},
            component: QuestPageComponent,
            canDeactivate: [UnsavedGuard]
          },
          {
            path: "arcs",
            data: {name: "Сюжетные арки"},
            component: QuestArcPageComponent,
            canDeactivate: [UnsavedGuard]
          }
        ]

      },
      {
        path: "offers",
        data: { name: "Офферы" },
        component: OffersPageComponent,
        canDeactivate: [UnsavedGuard]
        /*children: [
          {
            path: "offers",
            data: {name: "Обычные офферы"},
            document: OffersPageComponent,
            canDeactivate: [UnsavedGuard]
          }
        ]*/
      },
      ...GoPageRoutes,
      {
        path: "premiumShop",
        data: { name: "Магаз прем. валюты" },
        children: [
          {
            path: "lots",
            data: {name: "Лоты"},
            component: LotsPremiumShopPageComponent,
            canDeactivate: [UnsavedGuard]
          },
          {
            path: "offer-lots",
            data: {name: "Лоты для офферов"},
            component: OfferLotsComponent,
            canDeactivate: [UnsavedGuard]
          },
          {
            path: "levels",
            data: {name: "VIP уровни"},
            component: LevelsPremiumShopPageComponent,
            canDeactivate: [UnsavedGuard]
          }
        ]
      },
      {
        path: "achievements",
        data: { name: "Ачивки" },
        component: AchievementsPageComponent,
        canDeactivate: [UnsavedGuard]
      },
      {
        path: "spells",
        data: { name: "Заклинания" },
        component: SpellPageComponent,
        canDeactivate: [UnsavedGuard]
      },
      {
        path: "buffs",
        data: { name: "Баффы" },
        component: BuffsPageComponent,
        canDeactivate: [UnsavedGuard]
      },
      {
        path: "location",
        data: { name: "Локация" },
        children: [
          {
            path: "maps",
            data: { name: "Карты" },
            component: MapsLocationPageComponent,
            canDeactivate: [UnsavedGuard]
          },
          {
            path: "generators",
            data: { name: "Генераторы" },
            component: GeneratorsLocationPageComponent,
            canDeactivate: [UnsavedGuard]
          },
        ]
      },
      {
        path: "drop",
        data: { name: "Дропы" },
        component: DropAttributesPageComponent,
        canDeactivate: [UnsavedGuard]
      },
      {
        path: "gameEvents",
        data: {name: "Ивенты"},
		children: [
		  {	
			path: "gameEvents",
			data: {name: "Ивенты"},
			component: GameEventPageComponent,
			canDeactivate: [UnsavedGuard]
		  },
		  {
			path: "gameEventMap",
			data: {name: "Карта ивентов"},
			component: GameEventMapPageComponent,
			canDeactivate: [UnsavedGuard]
		  }
		]
      },
      {
        path: "attributes",
        data: { name: "Аттрибуты" },
        children: [
          {
            path: "levels",
            data: { name: "Уровни" },
            component: LevelsAttributesPageComponent,
            canDeactivate: [UnsavedGuard],

          },
          {
            path: "profile",
            data: { name: "Профиль, настройки" },
            component: ProfileAttributesPageComponent,
            canDeactivate: [UnsavedGuard]
          },
          {
            path: "weights",
            data: { name: "Шаблоны условий квестов" },
            component: WeightsAttributesPageComponent,
            canDeactivate: [UnsavedGuard]
          },
          {
            path: "ads",
            data: {name:"Реклама"},
            component: AdvertisementComponent,
            canDeactivate: [UnsavedGuard]
          }
        ]
      },
      {
        path: "dialogs",
        data: {name:"Диалоги"},
        children:
        [
          {
            path: "story",
            data: {name: "Сюжет"},
            component:StoryComponent
          },
          {
            path: "onmap",
            data: {name: "На карте"},
            component:OnmapDialogsComponent
          }
        ]
      },
      {
        path: "texts",
        data: { name: "Тексты" },
        component: TextPageComponent,
        canDeactivate: [UnsavedGuard]
      },
      {
        path: "consts",
        data: { name: "Константы" },
        component: ConstsPageComponent,
        canDeactivate: [UnsavedGuard]
      },
      {
        path:"lists",
        data:{name:"Списки"},
        children:[
          {
            path: "offer_types_list",
            data: {name:"Список типов офферов"},
            component:OfferTypesListPageComponent
          },
          {
            path: "geos_list",
            data: {name:"Список геолокаций"},
            component:GeosListPageComponent
          },
          {
            path: "locales_list",
            data: {name:"Список локалей"},
            component:LocalesListPageComponent
          },
          {
            path: "atlases",
            data: {name:"Атласы"},
            component:AtlasesComponent
          },
          {
            path: "monetary_groups",
            data: {name:"Группы полных чеков"},
            component:MonetaryGroupsPageComponent
          },
          {
            path: "frequency_groups",
            data: {name:"Группы частоты платежей"},
            component:FrequencyGroupsPageComponent
          },
          {
            path: "recency_groups",
            data: {name:"Группы времени платежей"},
            component:RecencyGroupsPageComponent
          },
          {
            path: "go_tags",
            data: {name:"Тэги"},
            component:GoTagsPageComponent
          },
          {
            path: "order_template_type",
            data: {name:"Типы шаблонов заказов"},
            component:TemplateTypesPageComponent
          },
          {
            path: "ad_nets",
            data: {name:"Рекламные сетки"},
            component:AdNetworksComponent
          }
        ]
      }/*,
      {
        path: "test",
        document: TestComponent
      }*/
    ]
  }
];


@NgModule({
  // imports: [createRoute(routes, {useHash: true})],
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
  providers: [
    AuthGuardService,
    AuthService,
    UnsavedGuard
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/app-routing.module.ts